import * as THREE from "three";

const loader = new THREE.TextureLoader();

export interface Sprite {
  mesh: THREE.Mesh;
  dispose(): void;
}

// A flat image plane (transparent PNG) sized to the image's aspect ratio.
// `height` is the world height; the width follows the texture aspect once it
// loads. Tagged skipEdges so the line-pass leaves the hand-drawn art alone.
export function createSprite(url: string, height: number): Sprite {
  const material = new THREE.MeshBasicMaterial({
    transparent: true,
    alphaTest: 0.5,
    side: THREE.DoubleSide,
    toneMapped: false,
  });
  const mesh = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), material);
  mesh.scale.set(height * 0.75, height, 1); // placeholder until the texture loads
  mesh.userData.skipEdges = true;

  const texture = loader.load(url, (t: THREE.Texture) => {
    const img = t.image as { width: number; height: number };
    const aspect = img.width / Math.max(1, img.height);
    mesh.scale.set(height * aspect, height, 1);
  });
  texture.colorSpace = THREE.SRGBColorSpace;
  material.map = texture;

  return {
    mesh,
    dispose() {
      material.map?.dispose();
      material.dispose();
      mesh.geometry.dispose();
    },
  };
}
